$(document).ready(function () {
	//if ($(document).find('.fb-page').length > 0) {
	//	$.each($(document).find('.fb-page'), function () {
	//		var fbPageWidth = $(this).parents('.k_col_container').css('width'),
	//			currentWidth = $(this).attr('data-width');
	//		var fbPageWidthInt = fbPageWidth.substr(0, 3) + 'px';
	//		if (currentWidth > fbPageWidth) {
	//			$(this).attr('data-width', fbPageWidthInt).attr('data-adapt-container-width', 'false');
	//			var fbPageId = $(this).parent().attr('id');
	//			$('#' + fbPageId).css('width', 'auto');
	//			FB.XFBML.parse();
	//		}
	//	})
	//}

	getValueNotify();

	$(document).on("submit", ".w_ajax_submit", submitFormLdp);

	$(document).on('click', '.k_btn_link, .k_icon, .k_img, .k_menu_bg', scrollToElement);
	$(document).on('click', '.k_btn_link, .k_icon, .k_img', showPopupElement);

	$.each($('.k_position_fixed'), function () {
		var positonThis = $(this).position().top,
			heightThis = $(this).outerHeight();

		if (positonThis >= $(window).outerHeight()) {
			$(this).css({
				'top': $(window).outerHeight() - 20 - heightThis
			})
		}
	});

	if ($(window).width() < 1360) {
		$('.k_overlay_video').hide();
	}
	else {
		$('.k_overlay_video').show();
	}

	$(document).on('click', '.w_close_popup_icon', closePopupDefault);
	$(document).on('click', '.popup_default_layout', closePopupDefault);

	$('.popup_default_layout .k_block').on('mouseenter mouseleave', function (e) {
		if (e.type === 'mouseenter') {
			checkMouse = 0;
		}
		else {
			checkMouse = 1;
		}
	});

	setUpPopupDefault();

	$('.k_icon_hamburger').parents('.k_block').css({
		'z-index': '99',
		'position': 'relative'
	});

	if (window.attachEvent) {
		window.attachEvent('onload', function () {
			FB.XFBML.parse();
			AjaxSaveVisit();
		});
	}
	else if (window.addEventListener) {
		window.addEventListener('load', function () {
			FB.XFBML.parse();
			AjaxSaveVisit();
		}, false);
	}
	else {
		document.addEventListener('load', function () {
			FB.XFBML.parse();
			AjaxSaveVisit();
		}, false);
	}

	$.each($('.k_element, .k_col, .k_row, .k_block'), function () {
		if (typeof $(this).data('class-animation') !== 'undefined') {
			$(this).addClass($(this).data('class-animation'));
		}
	});

	new WOW().init();

	$('a[href="#"]').click(function (event) {
		event.preventDefault();
	});

	var valueMenuDesktop = [];
	$.each($('.k_menu').find('.k_menu_bg'), function () {
		var valueContentMenu = $(this).find('a').html().trim(),
			valueLinkMenu = $(this).find('a').attr('href'),
			checkTargetBlank = typeof $(this).find('a').attr('target') === 'undefined' ? '_self' : $(this).find('a').attr('target');

		valueMenuDesktop.push([valueContentMenu, valueLinkMenu, checkTargetBlank]);
	});

	$('#slide-out').remove();
	$('body').prepend('<ul id="slide-out" class="side-nav"></ul>');

	for (var i = 0; i < valueMenuDesktop.length; i++) {
		$('#slide-out').append('<li><a class="truncate" href="' + valueMenuDesktop[i][1] + '" target="' + valueMenuDesktop[i][2] + '">' + valueMenuDesktop[i][0] + '</a></li>');
	}

	$(".button-collapse").sideNav({
		menuWidth: 250,
		edge: 'left'
	});

	$('body').removeClass('mobile_mode');
	if ($(window).outerWidth() <= 600) {
		$('body').addClass('mobile_mode').removeClass('desktop_and_tablet_mode');
		$('.mobile_mode .k_icon_hamburger').css({
			'left': 'calc((100% - ' + $(window).width() + 'px) / 2)',
			'top': '40px'
		});
	}

	autoResizeImg();

	$(window).resize(function () {
		if ($(window).outerWidth() <= 600) {
			$('body').addClass('mobile_mode').removeClass('desktop_and_tablet_mode');
		}
		else if ($(window).outerWidth() > 600) {
			$('body').addClass('desktop_and_tablet_mode').removeClass('mobile_mode');
		}
	});

	setWidhtHeightImg();
	addFontSizeText();

	$.each($('.change_fsize'), function () {
		if (!$('body').hasClass('mobile_mode')) {
			var fsize = $(this).data('fsize-desk');

			if (typeof fsize !== 'undefined' && fsize !== '') {
				$(this).css({
					'font-size': fsize
				})
			}
		}
		else {
			var fsize = $(this).data('fsize-mobi');

			if (typeof fsize !== 'undefined' && fsize !== '') {
				$(this).css({
					'font-size': fsize
				})
			}
		}
	});

	$(document).on('click', '#slide-out li', function () {
		$('.button-collapse').sideNav('hide');
	});

	//$(document).on("submit", "form", checkFormAjaxSubmit);

	$.each($(".k_form form"), function () {
		$(this).validate({
			rules: {
				email: {
					email: true
				}
			},
			messages: {
				name: {
					required: "* Bạn chưa nhập Họ tên *"
				},
				email: {
					required: "* Bạn chưa nhập Email *",
					email: "* Email chưa đúng định dạng (ví dụ: abc@domain.com) *"
				},
				phone: {
					required: "* Bạn chưa nhập Số điện thoại *"
				},
				address: {
					required: "* Bạn chưa nhập Địa chỉ *"
				}
			},
			errorElement: 'div',
			showErrors: function () {
				this.defaultShowErrors();
				$('.k_form form .input-field label').addClass('label_color');
				$('.k_form form .input-field i').addClass('label_color');
			},
			errorPlacement: function (error, element) {
				if (element.hasClass('k_form_item')) {
					element.after(error);
				}
				else {
					element.parents('.k_form_item').find('.k_form_item_title').append(error);
				}
			}
		});
	});

	jQuery.extend(jQuery.validator.messages, {
		required: "* Trường thông tin bắt buộc điền *"
	});

	$(document).on('keyup', 'input[name="phone"]', function () {
		$(this).val(function (index, value) {
			return value
			.replace(/[^0-9\s\+()]*/g, "");
		});
	});

	$('.k_form .input-field input').keyup(function () {
		$(this).parent().find('div').remove();
		$(this).removeClass('error');
	});

	if ($(document).find('.k_countdown').length > 0) {
		setInterval(countDown, 1000);
	}

	$(document).on("click", ".w_active_code_tracking", onClickCodeTracking);
	$(window).on('load', function () {
		if ($('.k_block[data-fixed-block="1"]').length) {
			var positionOrigin = $('.k_block[data-fixed-block="1"]').position().top,
				heightTarget = $('.k_block[data-fixed-block="1"]').height();

			$(window).on('scroll', function () {
				var target = $('.k_block[data-fixed-block="1"]');

				if (positionOrigin == 0) {
					target.addClass('fixed_block');
					$('body').css({
						'padding-top': heightTarget
					})
				}
				else if (positionOrigin <= $(window).scrollTop()) {
					target.addClass('fixed_block');
					$('body').css({
						'padding-top': heightTarget
					})
				}
				else if (positionOrigin > $(window).scrollTop()) {
					target.removeClass('fixed_block');
					$('body').css({
						'padding-top': 'unset'
					})
				}
			});
		}
	});
});

function autoResizeImg() {
	$(window).on('load', function () {
		$.each($('.k_img'), function () {
			var dataRatio,
				currentWidth = $(this).outerWidth();
			if($(this).attr('data-ratio-mobile')) {
				if($(window).width() < 600) {
					dataRatio =  $(this).attr('data-ratio-mobile');
				}
				else {
					dataRatio = $(this).attr('data-ratio-desktop');
				}
			}
			else {
				dataRatio = $(this).attr('data-ratio-desktop');
			}

			$(this).find('.k_element_child').css('height', currentWidth/ dataRatio + 'px');
			$(this).find('.k_element_child').css('min-height', currentWidth/ dataRatio + 'px');
		});
	});
}

function showLoadingPage() {
	$('#i_loading_overlay').show();
}

function hideLoadingPage() {
	setTimeout(function () {
		$("#i_loading_overlay").hide();
	}, 200);
}

//function checkFormAjaxSubmit(e) {
//	var checkAll = !0;
//	var form = $(this);
//	var selector = createInputSelector(":not(.disable_validate),");
//
//	form.find(selector).each(function () {
//		var temp = checkValueForm(e, $(this));
//		checkAll = checkAll && temp;
//	});
//
//	if (checkAll) {
//		ajaxSubmitForm(form);
//	}
//
//	e.preventDefault();
//
//	return !1;
//}

//function ajaxSubmitForm(form) {
//	var btn = form.find("button[type='submit']");
//	btn.addClass('disabled');
//
//	showLoadingPage();
//
//	form.ajaxSubmit({
//		type: "POST",
//		dataType: "json",
//		cache: !1,
//		success: function (data) {
//			if (window[data.callback]) {
//				console.log("Callback: ", data.callback);
//				window[data.callback](data, form, btn);
//			}
//			else {
//				console.log("Callback not found:'", data.callback, "'-->Call 'defaultFormSubmitRespone' instead");
//				defaultFormSubmitRespone(data, form, btn);
//			}
//		},
//		error: function () {
//			btn.html('Thất bại ...');
//			btn.removeClass('disabled');
//		},
//		complete: function (jqXHR, textStatus) {
//			hideLoadingPage();
//		}
//	});
//}

function checkValueForm(e, source_obj) {
	return true; //TODO: validate in client

	var obj;

	if (source_obj) {
		obj = source_obj;
	}
	else {
		obj = $(this);
	}

	if (!obj.hasOwnProperty("closest")) {
		return true;
	}

	var parent = obj.closest(".form-group");
	var value = $.trim(obj.val());
	if (obj.attr("type") == "number") {
		if (value.length != 0) {
			if (!(!isNaN(parseFloat(value)) && isFinite(value))) {
				change_error_state(obj, false);
				parent.find("label.help-block").html("Dữ liệu nhập vào là số");
				return false;
			}
			else {
				change_error_state(obj, true);
			}
		}
	}
	if (obj.attr("required") != undefined && obj.attr("required") != "0") {
		if (value.length == 0) {
			change_error_state(obj, false);
			parent.find("label.help-block").html("Trường này là bắt buộc");
			return false;
		}
		else {
			change_error_state(obj, true);
		}
	}
	if (obj.attr("minlength") != undefined && obj.attr("minlength") > 1) {
		if (value.length < obj.attr("minlength")) {
			change_error_state(obj, false);
			parent.find("label.help-block").html("Độ dài tối thiểu là " + obj.attr("minlength") + " ký tự");
			return false;
		}
		else {
			change_error_state(obj, true);
		}
	}
	if (obj.attr("maxlength") != undefined && obj.attr("maxlength") > 1) {
		if (value.length > obj.attr("maxlength")) {
			change_error_state(obj, false);
			parent.find("label.help-block").html("Độ dài tối đa là " + obj.attr("maxlength") + " ký tự");
			return false;
		}
		else {
			change_error_state(obj, true);
		}
	}

	if (obj.attr("is_email") != undefined && obj.attr("is_email") != 0) {
		if (obj.attr("required") == undefined || obj.attr("required") == "0") {
			change_error_state(obj, true);
		}
		else {
			if (!is_email(value)) {
				change_error_state(obj, false);
				parent.find("label.help-block").html("Trường này yêu cầu là email!");
				return false;
			}
			else {
				change_error_state(obj, true);
			}
		}
	}
	if (obj.attr("recheck") != undefined && obj.attr("recheck") != 0) {
		var selector = creat_input_selector("[name='" + obj.attr("recheck") + "']");
		if (value != $(selector).val()) {
			change_error_state(obj, false);
			parent.find("label.help-block").html("Dữ liệu nhập lại không đúng");
			return false;
		}
		else {
			change_error_state(obj, true);
		}
	}

	if (obj.attr("allow_null") == undefined && obj.prop("tagName") == "SELECT") {
		if (value == 0) {
			change_error_state(obj, false);
			parent.find("label.help-block").html("Trường này không được bỏ trống");
			return false;
		}
		else {
			change_error_state(obj, true);
		}
	}
	change_error_state(obj, true);
	return true;
}


/**
 * Handle response data when submit form
 * @param {object} data
 * @param {jQuery} form
 * @param {jQuery} button
 */
function defaultFormSubmitRespone(data, form, button) {
	button.removeAttr('disabled');

	if (data.state === 1) { /* Thành công */
		// button.removeClass('btn-danger');
		// button.addClass('btn-success');
		// button.html('Thành công ...');
		jgrow = "alert-success";
	}
	else {
		// button.addClass('btn-danger');
		// button.removeClass('btn-success');
		// button.html('Không rõ kết quả');
	}

	if (data.hasOwnProperty("msg")) {
		var msg = data.msg;
		if (data.hasOwnProperty("error")) {
			for (var k in data.error) {
				msg += '\n ・' + data.error[k];
			}

			alert(msg);
		}
	}

	if (data.hasOwnProperty("redirect")) {
		if (form.data('thankyou') === 1) {
			$("#i_thankyou_popup").modal({
				dismissible: !0,
				inDuration: 300,
				outDuration: 200,
				startingTop: '3%',
				endingTop: '20%'
			});

			$("#i_thankyou_popup").modal('open');
			$('.popup_default_layout').addClass('hide');
		}
		else {
			window.location = data.redirect;
		}
	}

	if (data.hasOwnProperty("reload")) {
		setTimeout(function () {
			window.location.reload();
		}, 3000);
	}
}

/**
 *
 * @param {object} errorList list of error, object {key:value}<br/>
 *                       key is name of input, value is error message
 * @returns {undefined}
 */
function show_error(errorList, form) {
	var selector = creat_input_selector("");
	form.find(selector).each(function () {
		var name = $(this).attr("name");
		if (name) {
			name = name.replace("[]", "");
			if (errorList.hasOwnProperty(name)) {
				var parent = $(this).closest(".form-group");
				change_error_state($(this), false);
				parent.find("label.help-block").html(errorList[name]);
			}
			else {
				change_error_state($(this), true);
			}
		}
	});
}

/**
 * Change error state of input in form
 * @param {jQuery} obj
 * @param {bool} is_valid
 * @returns change View
 */
function change_error_state(obj, is_valid) {
	var parent = obj.closest(".form-group");
	if (is_valid) {
		parent.removeClass("has-error");
		parent.addClass("has-success");
		parent.find("label.help-block").hide();
	}
	else {
		parent.removeClass("has-success");
		parent.addClass("has-error");
		var error = parent.find("label.help-block"); //length;//.children(".error");
		if (error.length) {
			error.show();
		}
		else {
			parent.append("<label class='help-block col-sm-8 col-xs-12 col-sm-offset-3'></label>").show();
		}
	}
}

/**
 * validate email
 * @param {String} email
 * @returns {boolean}
 */
function is_email(email) {
	var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
	return pattern.test(email);
}

function createInputSelector(more) {
	var input = "input,select,radio,textarea";
	var temp = input.split(",");
	var selector = "";

	if (more.substr(more.length - 1) != ",") {
		selector = temp.join(more + ",") + more;
	}
	else {
		selector = temp.join(more) + more.slice(0, more.length - 1);
	}

	return selector;
}

function countDown() {
	$.each($('.k_countdown'), function () {
		var valueStart;
		var valueEnd;
		var distanceLoop;
		var countDownDateStart;
		var countDownDateEnd;
		var timeLoop,
			targetId,
			distance,
			countDownDateEndLoop;
		var target = $(this).attr('id');

		targetId = '#' + target;
		valueStart = $(this).attr('data-value-start');
		valueEnd = $(this).attr('data-value-end');
		timeLoop = $(this).attr('data-loop');
		if (valueStart) {
			var dayInputStart = valueStart.substr(0, 2);
			var monthInputStart = valueStart.substr(3, 2);
			var yearInputStart = valueStart.substr(6);
		}
		else {
			countDownDateStart = new Date().getTime();
		}
		if (valueEnd) {
			var dayInputEnd = valueEnd.substr(0, 2);
			var monthInputEnd = valueEnd.substr(3, 2);
			var yearInputEnd = valueEnd.substr(6);

			countDownDateEnd = new Date(yearInputEnd + '-' + monthInputEnd + '-' + dayInputEnd + 'T23:59:59+07:00').getTime();
		}
		else {
			countDownDateEnd = '';
		}

		if (timeLoop !== 'off') {
			distanceLoop = parseInt(timeLoop) * 86400000;
		}

		if (countDownDateEnd !== '') {
			countDownDateStart = new Date(yearInputStart + '-' + monthInputStart + '-' + dayInputStart + 'T00:00:00+07:00').getTime();
			if (countDownDateStart + distanceLoop <= new Date().getTime()) {
				var currentTime = new Date(),
					currentYear = currentTime.getFullYear(),
					currentMonth = currentTime.getMonth() + 1,
					currentDay = currentTime.getDate();
				if (0 < currentMonth && currentMonth <= 9) {
					currentMonth = '0' + currentMonth;
				}
				if (0 < currentDay && currentDay <= 9) {
					currentDay = '0' + currentDay
				}
				countDownDateStart = new Date(currentMonth + '/' + currentDay + '/' + currentYear + ' ' + '00:00:00').getTime();
			}
			if (countDownDateStart - new Date().getTime() <= 0) {
				if (timeLoop === 'off') {
					countDownDateStart = new Date().getTime();
					distance = countDownDateEnd - countDownDateStart;
				}
				else {
					countDownDateEndLoop = countDownDateStart + distanceLoop;
					countDownDateStart = new Date().getTime();
					if (countDownDateEndLoop >= countDownDateEnd || (countDownDateEnd - new Date().getTime()) < distanceLoop) {
						distance = countDownDateEnd - countDownDateStart;
					}
					else {
						distance = countDownDateEndLoop - countDownDateStart;
						if (distance === 0) {
							countDownDateStart = new Date().getTime();
						}
					}
				}
			}
			else {
				if (timeLoop === 'off') {
					distance = countDownDateEnd - countDownDateStart;
				}
				else {
					distanceLoop = parseInt(timeLoop) * 86400000;
					countDownDateEndLoop = countDownDateStart + distanceLoop;
					if (countDownDateEndLoop >= countDownDateEnd || (countDownDateEnd - new Date().getTime()) < distanceLoop) {
						distance = countDownDateEnd - countDownDateStart;
					}
					else {
						distance = countDownDateEndLoop - countDownDateStart;
						if (distance === 0) {
							countDownDateStart = new Date().getTime();
						}
					}
				}
			}

			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);

			if (distance > 0) {
				if (days >= 0 && days <= 9) {
					$(targetId).find('.j_countdown_day').html("<p>0" + days + "</p>");
				}
				else {
					$(targetId).find('.j_countdown_day').html("<p>" + days + "</p>");
				}

				if (hours >= 0 && hours <= 9) {
					$(targetId).find('.j_countdown_hour').html("<p>0" + hours + "</p>");
				}
				else {
					$(targetId).find('.j_countdown_hour').html("<p>" + hours + "</p>");
				}

				if (minutes >= 0 && minutes <= 9) {
					$(targetId).find('.j_countdown_minute').html("<p>0" + minutes + "</p>");
				}
				else {
					$(targetId).find('.j_countdown_minute').html("<p>" + minutes + "</p>");
				}

				if (seconds >= 0 && seconds <= 9) {
					$(targetId).find('.j_countdown_second').html("<p>0" + seconds + "</p>");
				}
				else {
					$(targetId).find('.j_countdown_second').html("<p>" + seconds + "</p>");
				}
			}
			else {
				$(targetId).find('.j_countdown_day').html("<p>00</p>");
				$(targetId).find('.j_countdown_hour').html("<p>00</p>");
				$(targetId).find('.j_countdown_minute').html("<p>00</p>");
				$(targetId).find('.j_countdown_second').html("<p>00</p>");
			}
		}
	})
}

function onClickCodeTracking(e) {
	var dataCodeTracking = $(this).data('codetracking');

	if (typeof dataCodeTracking !== 'undefined') {
		try {
			eval(dataCodeTracking)
		}
		catch (e) {
		}
	}
}

//slideshow
var slideIndex = 0,
	backgroundSlideIndex = 0;
$(document).ready(function () {
	autoBackgroundSlide();
	autoSlide();

	$(document).find('.k_slideshow').css('overflow', 'hidden');
	$(document).find('.k_block.overflow_hidden_slide').css('overflow-x', 'hidden');

	$(document).on("click", ".w_slideshow_pre_icon", function preDivs() {
		var target = $(this).parents('.k_slideshow').attr('id');
		showDivs(slideIndex = slideIndex - 1, '#' + target);
	});
	$(document).on("click", ".w_slideshow_next_icon", function nextDivs() {
		var target = $(this).parents('.k_slideshow').attr('id');
		showDivs(slideIndex = slideIndex + 1, '#' + target);
	});
	$(document).on("click", ".w_bg_slide_pre_icon", function preBackground() {
		var target = $(this).parents('.k_block').attr('id');
		showBackground(backgroundSlideIndex = backgroundSlideIndex - 1, '#' + target);
	});
	$(document).on("click", ".w_bg_slide_next_icon", function nextBackground() {
		var target = $(this).parents('.k_block').attr('id');
		showBackground(backgroundSlideIndex = backgroundSlideIndex + 1, '#' + target);
	});

	var trackingScroll = [],
		scrollToTop = 0;
	$(window).on("mousewheel", function () {
		if (typeof pixelCheck !== 'undefined' && pixelCheck === 1) {
			scrollToTop = $(window).scrollTop();

			var position = Math.round((scrollToTop + $(window).outerHeight()) / $("body").outerHeight() * 100);

			if (position <= 25 && -1 === trackingScroll.indexOf(25)) {
				trackingScroll.push(25);
				fbq("trackCustom", "Scroll_25_percent");
			}
			else if (position > 25 && position <= 50 && -1 === trackingScroll.indexOf(50)) {
				trackingScroll.push(50);
				fbq("trackCustom", "Scroll_50_percent");
			}
			else if (position > 50 && position <= 75 && -1 === trackingScroll.indexOf(75)) {
				trackingScroll.push(75);
				fbq("trackCustom", "Scroll_75_percent");
			}
			else if (position > 75 && position <= 100 && -1 === trackingScroll.indexOf(100)) {
				trackingScroll.push(100);
				fbq("trackCustom", "Scroll_100_percent");
			}
		}
	});

	$(window).on("scroll", function () {
		if (typeof pixelCheck !== 'undefined' && pixelCheck === 1) {
			scrollToTop = $(window).scrollTop();

			var position = Math.round((scrollToTop + $(window).outerHeight()) / $("body").outerHeight() * 100);

			if (position <= 25 && -1 === trackingScroll.indexOf(25)) {
				trackingScroll.push(25);
				fbq("trackCustom", "Scroll_25_percent")
			}
			else if (position > 25 && position <= 50 && -1 === trackingScroll.indexOf(50)) {
				trackingScroll.push(50);
				fbq("trackCustom", "Scroll_50_percent")
			}
			else if (position > 50 && position <= 75 && -1 === trackingScroll.indexOf(75)) {
				trackingScroll.push(75);
				fbq("trackCustom", "Scroll_75_percent")
			}
			else if (position > 75 && position <= 100 && -1 === trackingScroll.indexOf(100)) {
				trackingScroll.push(100);
				fbq("trackCustom", "Scroll_100_percent")
			}
		}
	});

	if (typeof pixelCheck !== 'undefined' && pixelCheck === 1) {
		setTimeout(function () {
			fbq("trackCustom", "TimeOnPage_10_seconds");
		}, 10000);

		setTimeout(function () {
			fbq("trackCustom", "TimeOnPage_30_seconds");
		}, 30000);

		setTimeout(function () {
			fbq("trackCustom", "TimeOnPage_1_minute");
		}, 60000);

		setTimeout(function () {
			fbq("trackCustom", "TimeOnPage_2_minutes");
		}, 120000);

		setTimeout(function () {
			fbq("trackCustom", "TimeOnPage_3_minutes");
		}, 180000);

		setTimeout(function () {
			fbq("trackCustom", "TimeOnPage_5_minutes");
		}, 300000);
	}
});

function autoSlide() {
	$.each($('.k_slideshow'), function () {
		var setIntervalSlideshow;
		var target = $(this).attr('id'),
			valueTime = $(this).attr('data-time');
		if (valueTime !== 'off') {
			var intervalTime = valueTime * 1000;
			showDivs(slideIndex = slideIndex + 1, '#' + target);

			if ($('#' + target).hasClass('w_slideshow_pause') && $(window).width() > 1024) {
				setIntervalSlideshow = setInterval(function () {
					showDivs(slideIndex = slideIndex + 1, '#' + target);
				}, intervalTime);

				$('#' + target).mouseenter(function () {
					$(this).stop();
					clearInterval(setIntervalSlideshow);
				});
				$('#' + target).mouseleave(function () {
					setIntervalSlideshow = setInterval(function () {
						showDivs(slideIndex = slideIndex + 1, '#' + target);
					}, intervalTime);
				});
			}
			else {
				setInterval(function () {
					showDivs(slideIndex = slideIndex + 1, '#' + target);
				}, intervalTime);
			}
		}
	});
}

function showDivs(n, target) {
	var i;
	var x = $(target).find('.b_slideshow_item');
	if (n > x.length) {
		slideIndex = 1
	}
	if (n < 1) {
		slideIndex = x.length
	}
	;
	for (i = 0; i < x.length; i++) {
		x[i].style.display = "none";
	}
	x[slideIndex - 1].style.display = "block";
}

function autoBackgroundSlide() {
	$.each($('.k_block'), function () {
		var setIntervalSlideBg;
		var target = $(this).attr('id'),
			autoBgSlideTime = $(this).attr('data-time');
		if (autoBgSlideTime && autoBgSlideTime !== 'undefined') {
			var intervalSlideBgTime = autoBgSlideTime * 1000;
			showBackground(backgroundSlideIndex = backgroundSlideIndex + 1, '#' + target);
			if ($('#' + target).hasClass('w_slide_background_pause') && $(window).width() > 1024) {

				setIntervalSlideBg = setInterval(function () {
					showBackground(backgroundSlideIndex = backgroundSlideIndex + 1, '#' + target);
				}, intervalSlideBgTime);
				$('.w_slide_background_pause[id="' + target + '"]').mouseenter(function () {
					$(this).stop();
					clearInterval(setIntervalSlideBg);
				});
				$('.w_slide_background_pause[id="' + target + '"]').mouseleave(function () {
					setIntervalSlideBg = setInterval(function () {
						showBackground(backgroundSlideIndex = backgroundSlideIndex + 1, '#' + target);
					}, intervalSlideBgTime);
				});
			}
			else {
				setIntervalSlideBg = setInterval(function () {
					showBackground(backgroundSlideIndex = backgroundSlideIndex + 1, '#' + target);
				}, intervalSlideBgTime);

				$('#' + target).find('.w_reset_auto_slide').click(function () {
					$(this).stop();
					clearInterval(setIntervalSlideBg);
					setIntervalSlideBg = setInterval(function () {
						showBackground(backgroundSlideIndex = backgroundSlideIndex + 1, '#' + target);
					}, intervalSlideBgTime);
				});
			}
		}
	});
}

function showBackground(n, target) {
	var i;
	var x = $(target).find('.b_slide_background_item');
	if (n > x.length) {
		backgroundSlideIndex = 1
	}
	if (n < 1) {
		backgroundSlideIndex = x.length;
	}

	for (i = 0; i < x.length; i++) {
		x[i].style.display = "none";
	}
	x[backgroundSlideIndex - 1].style.display = "block";
}

var checkMouse = 1;

function setUpPopupDefault() {
	$.each($('.popup_default_layout'), function () {
		var target = $(this),
			dataOpen = target.data('open'),
			dataDelay = target.data('delay'),
			dataMobile = target.data('mobile'),
			dataLink = target.data('link'),
			dataAnimation = target.data('animation');

		if ($(window).width() >= 768) {
			setUpPopupDefaultChild(dataOpen, target, dataDelay, dataLink, dataAnimation);
		}
		else {
			if (dataMobile) {
				setUpPopupDefaultChild(dataOpen, target, dataDelay, dataLink, dataAnimation);
			}
		}
	});
}

function setUpPopupDefaultChild(dataOpen, target, dataDelay, dataLink, dataAnimation) {
	if (dataOpen) {
		settingPopup(target, dataDelay, dataAnimation);
	}

	if (dataLink && typeof dataLink !== undefined) {
		if (dataOpen) {
			settingPopup(target, dataDelay, dataAnimation);
		}

		var positionTop = $('#' + dataLink).position().top,
			checkScrollPopup = 1;

		if (positionTop === 0) {
			settingPopup(target, dataDelay, dataAnimation);
		}
		else {
			$(window).on('scroll', function () {
				if (checkScrollPopup) {
					if (($(window).scrollTop() + 700) > positionTop) {
						settingPopup(target, dataDelay, dataAnimation);
						checkScrollPopup = 0;
					}
				}
			});
		}
	}
}

function settingPopup(target, dataDelay, dataAnimation) {
	target.find('.k_block').addClass('animated ' + dataAnimation);
	setTimeout(function () {
		$('.popup_default_layout').addClass('hide');
		target.removeClass('hide');

		checkScrollPopupMobileScroll();
	}, dataDelay * 1000);
}

function checkScrollPopupMobileScroll() {
	if ($('.popup_default_bg').find('.k_block').height() > $(window).outerHeight()) {
		$('.popup_default_bg').find('.k_block').css({
			'overflow-y': 'scroll',
			'height': $(window).outerHeight() + 'px'
		});
	}
	else {
		$('.popup_default_bg').find('.k_block').css({
			'overflow-y': 'unset',
			'height': 'unset'
		});
	}
}

function closePopupDefault() {
	if ($(this).is('.w_close_popup_icon')) {
		$(this).parents('.popup_default_layout').addClass('hide');
	}
	else {
		var target = $('.popup_default_layout').not('hide');
		if (checkMouse === 1 && target.data('layout-close') === 1) {
			$('.popup_default_layout').addClass('hide');
		}
	}
}

function showPopupElement() {
	var idPopup = $(this).find('a').data('id');
	if (idPopup !== '' && typeof idPopup !== 'undefined' && idPopup.search('popup') !== -1) {
		$('#' + idPopup).find('.k_block').addClass('animated ' + $('#' + idPopup).data('animation'));
		$('.popup_default_layout').addClass('hide');
		$('#' + idPopup).removeClass('hide');

		checkScrollPopupMobileScroll();
	}
}

function scrollToElement() {
	let target = $(this).find('a').attr('href');
	let count = 0;

	if ($(document).find('.k_menu').length > 0 && $('.k_menu').parents('.k_block').data('fixed-block') === 1) {
		count = $('.k_menu').parents('.k_block').height();
	}

	if (target.search('#ki_block') != -1) {
		$('html, body').animate({
			scrollTop: $(target).offset().top - count
		});
	}
}

function setWidhtHeightImg() {
	$.each($('.k_img'), function () {
		var width = $(this).width();
		if (!$('body').hasClass('mobile_mode')) {
			var ratio = $(this).data('ratio-desktop'),
				height = width / ratio;

			if (typeof ratio !== 'undefined' && ratio !== '') {
				$('#' + $(this).attr('id')).find('.k_element_child').css({'height': height + 'px', 'min-height': height + 'px'});
			}
		}
		else {
			var ratio = $(this).data('ratio-mobile'),
				height = width / ratio;

			if (typeof ratio !== 'undefined' && ratio !== '') {
				$('#' + $(this).attr('id')).find('.k_element_child').css({'height': height + 'px', 'min-height': height + 'px'});
			}
		}
	});
}

function submitFormLdp(e) {
	var form = $(this),
		ldpId = $(this).attr('data-ldp'),
		link = location.protocol + '//' + location.host + location.pathname,
		httpReferer = document.referrer,
		created =  Math.floor(Date.now() / 1000),
		dataIp = '',
		userId =  $(this).attr('data-user-id'),
		dataToEzimar =  $(this).parents('.k_form').attr('data-to-ezimar'),
		formCode =  $(this).parents('.k_form').attr('data-form-code'),
		urlParams = new URLSearchParams(window.location.search),
		checksumCode;
	if(urlParams.get('checksum_code') !== null) {
		checksumCode = urlParams.get('checksum_code');
	}
	else {
		checksumCode = '';
	}
	showLoadingPage();
	$('<input />').attr('type', 'hidden').attr('name', "ip").attr('value', '').appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "landingpage_id").attr('value', ldpId).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "checksum_code").attr('value', checksumCode).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "link").attr('value', link).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "http_referer").attr('value', httpReferer).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "created_on").attr('value', created).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "user_id").attr('value', userId).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "data_to_ezimar").attr('value', dataToEzimar).appendTo(form);
	$('<input />').attr('type', 'hidden').attr('name', "form_code").attr('value', formCode).appendTo(form);
	AjaxSubmitForm(form, e);
}

function AjaxSubmitForm(form, e) {
	e.preventDefault();
	let $form = form;

	$.post( $form.attr('action'), $form.serialize(), function(response) {
		let responseSubmit = $.parseJSON(response);
		if(response.state === 1) {
			jgrow = "alert-success";
		}
		if (response.hasOwnProperty("msg")) {
			var msg = responseSubmit.msg;
			if (responseSubmit.hasOwnProperty("error")) {
				for (var k in responseSubmit.error) {
					msg += '\n ・' + responseSubmit.error[k];
				}

				alert(msg);
			}
		}
		if (responseSubmit.hasOwnProperty("redirect")) {
			if ($form.attr('data-thankyou') === '1') {
				$("#i_thankyou_popup").modal({
					dismissible: !0,
					inDuration: 300,
					outDuration: 200,
					startingTop: '3%',
					endingTop: '20%'
				});

				$("#i_thankyou_popup").modal('open');
				$('.popup_default_layout').addClass('hide');
			}
			else {
				window.location = responseSubmit.redirect;
			}
		}

		if (responseSubmit.hasOwnProperty("reload")) {
			setTimeout(function () {
				window.location.reload();
			}, 3000);
		}
		hideLoadingPage();
	});
	return false;
}

function AjaxSaveVisit() {
	var dataUrl = $(document).find('.k_css_wrapper').attr('data-url'),
		ldpId = $(document).find('.k_css_wrapper').attr('data-ldp'),
		link = location.protocol + '//' + location.host + location.pathname,
		httpReferer = document.referrer,
		dataIp = '',
		created =  Math.floor(Date.now() / 1000),
		userId = $(document).find('.k_css_wrapper').attr('data-user-id'),
		urlParams = new URLSearchParams(window.location.search),
		checksumCode;
	if(urlParams.get('checksum_code') !== null) {
		checksumCode = urlParams.get('checksum_code');
	}
	else {
		checksumCode = '';
	}

	var visited = getCookie("visited_" + ldpId);
	if (visited !== "1") {
		$.getJSON('https://ipinfo.io', function(result){
			dataIp = result['ip'];
			var data = {
				'landingpage_id': ldpId,
				'user_id': userId,
				'link': link,
				'http_referer': httpReferer,
				'ip': dataIp,
				'created_on': created,
				'checksum_code': checksumCode
			};
			$.ajax({
				url: dataUrl,
				type: "POST",
				data: data,
				dataType: "json",
				success: function (data) {
					if(data.state === 0) {
						swal({
							title: 'Đã xảy ra lỗi!',
							type: 'error',
							html: data.msg,
							confirmButtonClass: 'btn waves-effect btn-ezimar-primary ezimar_green',
							buttonsStyling: !1
						});
					}
				},
				complete: function () {

				}
			});
		});
		setCookie("visited_" + ldpId);
	}
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function setCookie(cname) {
	var d = new Date();
	d.setTime(d.getTime() + (5 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + '1' + ";" + expires + ";path=/";
}

function addFontSizeText() {
	$.each($('.k_text'), function () {
		if (!$('body').hasClass('mobile_mode')) {
			var fsize = $(this).data('fsize-desk');

			if (typeof fsize !== 'undefined' && fsize !== '') {
				$(this).find('.k_text_tinymce').children().first().css({
					'font-size': fsize + 'px'
				});
			} else {
				var fsize2 = $(this).find('.k_text_tinymce').children().first().css('font-size');

				$(this).removeData('fsize-desk').attr({
					'data-fsize-desk': parseInt(fsize2)
				});
			}
		}
		else {
			var fsize = $(this).data('fsize-mobi');

			if (typeof fsize !== 'undefined' && fsize !== '') {
				$(this).find('.k_text_tinymce').children().first().css({
					'font-size': fsize + 'px'
				});
			} else {
				var fsize2 = $(this).find('.k_text_tinymce').children().first().css('font-size');

				$(this).removeData('fsize-mobi').attr({
					'data-fsize-mobi': parseInt(fsize2)
				});
			}
		}
	});
}

function getValueNotify() {
	var idGoogleSheet = $('.js_notify_info').data('id-googlesheet'),
		themeNotify = $('.js_notify_info').data('theme-notify'),
		positionNotify = $('.js_notify_info').data('position-notify'),
		timeNotify = $('.js_notify_info').data('time-notify');

	if (typeof idGoogleSheet !== 'undefined' && idGoogleSheet !== '') {
		$.ajax({
			url: 'https://spreadsheets.google.com/feeds/list/' + idGoogleSheet + '/1/public/values?alt=json',
			dataType: 'json',
			success: function(value) {
				var data = value.feed.entry;
				var count = 0;
	
				setInterval(function() {
	
					var notify = data[count].gsx$notify['$t'];
					var time = data[count].gsx$time['$t'];
	
					$('div[data-notify="container"]').remove();
					setUpNotyFake(themeNotify, notify + '<br>' + time, 1000, positionNotify.split('_')[0], positionNotify.split('_')[1]);
	
					if (count === (data.length - 1)) {
						count = 0;
					} else {
						count += 1;
					}
				}, timeNotify * 60 * 1000);
			}
		});
	}
}

function setUpNotyFake(notyType, notyContent, notyTimeOut, notyFrom, notyAlign) {
	if (!notyTimeOut) {
		notyTimeOut = 2000;
	}

	$.notify({
		icon: 'notifications',
		message: notyContent
	}, {
		type: notyType,
		timer: notyTimeOut,
		placement: {
			from: notyFrom,
			align: notyAlign
		}
	});
}

/*
 * Project: Bootstrap Notify = v3.1.3
 * Description: Turns standard Bootstrap alerts into "Growl-like" notifications.
 * Author: Mouse0270 aka Robert McIntosh
 * License: MIT License
 * Website: https://github.com/mouse0270/bootstrap-growl
 */

/* global define:false, require: false, jQuery:false */

(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['jquery'], factory);
	}
	else if (typeof exports === 'object') {
		// Node/CommonJS
		factory(require('jquery'));
	}
	else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {
	// Create the defaults once
	var defaults = {
		element: 'body',
		position: null,
		type: "info",
		allow_dismiss: true,
		allow_duplicates: true,
		newest_on_top: false,
		showProgressbar: false,
		placement: {
			from: "top",
			align: "right"
		},
		offset: 20,
		spacing: 10,
		z_index: 1031,
		delay: 5000,
		timer: 1000,
		url_target: '_blank',
		mouse_over: null,
		animate: {
			enter: 'c_notify_animated fadeInDown',
			exit: 'c_notify_animated fadeOutUp'
		},
		onShow: null,
		onShown: null,
		onClose: null,
		onClosed: null,
		icon_type: 'class',
		template: '<div data-notify="container" class="col s11 m3 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="material-icons-extended">close</i></button><i data-notify="icon" class="material-icons-extended"></i><span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
	};

	String.format = function () {
		var str = arguments[0];
		for (var i = 1; i < arguments.length; i++) {
			str = str.replace(RegExp("\\{" + (i - 1) + "\\}", "gm"), arguments[i]);
		}
		return str;
	};

	function isDuplicateNotification(notification) {
		var isDupe = false;

		$('[data-notify="container"]').each(function (i, el) {
			var $el = $(el);
			var title = $el.find('[data-notify="title"]').text().trim();
			var message = $el.find('[data-notify="message"]').html().trim();

			// The input string might be different than the actual parsed HTML string!
			// (<br> vs <br /> for example)
			// So we have to force-parse this as HTML here!
			var isSameTitle = title === $("<div>" + notification.settings.content.title + "</div>").html().trim();
			var isSameMsg = message === $("<div>" + notification.settings.content.message + "</div>").html().trim();
			var isSameType = $el.hasClass('alert-' + notification.settings.type);

			if (isSameTitle && isSameMsg && isSameType) {
				//we found the dupe. Set the var and stop checking.
				isDupe = true;
			}
			return !isDupe;
		});

		return isDupe;
	}

	function Notify(element, content, options) {
		// Setup Content of Notify
		var contentObj = {
			content: {
				message: typeof content === 'object' ? content.message : content,
				title: content.title ? content.title : '',
				icon: content.icon ? content.icon : '',
				url: content.url ? content.url : '#',
				target: content.target ? content.target : '-'
			}
		};

		options = $.extend(true, {}, contentObj, options);
		this.settings = $.extend(true, {}, defaults, options);
		this._defaults = defaults;
		if (this.settings.content.target === "-") {
			this.settings.content.target = this.settings.url_target;
		}
		this.animations = {
			start: 'webkitAnimationStart oanimationstart MSAnimationStart animationstart',
			end: 'webkitAnimationEnd oanimationend MSAnimationEnd animationend'
		};

		if (typeof this.settings.offset === 'number') {
			this.settings.offset = {
				x: this.settings.offset,
				y: this.settings.offset
			};
		}

		//if duplicate messages are not allowed, then only continue if this new message is not a duplicate of one that it already showing
		if (this.settings.allow_duplicates || (!this.settings.allow_duplicates && !isDuplicateNotification(this))) {
			this.init();
		}
	}

	$.extend(Notify.prototype, {
		init: function () {
			var self = this;

			this.buildNotify();
			if (this.settings.content.icon) {
				this.setIcon();
			}
			if (this.settings.content.url != "#") {
				this.styleURL();
			}
			this.styleDismiss();
			this.placement();
			this.bind();

			this.notify = {
				$ele: this.$ele,
				update: function (command, update) {
					var commands = {};
					if (typeof command === "string") {
						commands[command] = update;
					}
					else {
						commands = command;
					}
					for (var cmd in commands) {
						switch (cmd) {
							case "type":
								this.$ele.removeClass('alert-' + self.settings.type);
								this.$ele.find('[data-notify="progressbar"] > .progress-bar').removeClass('progress-bar-' + self.settings.type);
								self.settings.type = commands[cmd];
								this.$ele.addClass('alert-' + commands[cmd]).find('[data-notify="progressbar"] > .progress-bar').addClass('progress-bar-' + commands[cmd]);
								break;
							case "icon":
								var $icon = this.$ele.find('[data-notify="icon"]');
								if (self.settings.icon_type.toLowerCase() === 'class') {
									$icon.html(commands[cmd]);
								}
								else {
									if (!$icon.is('img')) {
										$icon.find('img');
									}
									$icon.attr('src', commands[cmd]);
								}
								break;
							case "progress":
								var newDelay = self.settings.delay - (self.settings.delay * (commands[cmd] / 100));
								this.$ele.data('notify-delay', newDelay);
								this.$ele.find('[data-notify="progressbar"] > div').attr('aria-valuenow', commands[cmd]).css('width', commands[cmd] + '%');
								break;
							case "url":
								this.$ele.find('[data-notify="url"]').attr('href', commands[cmd]);
								break;
							case "target":
								this.$ele.find('[data-notify="url"]').attr('target', commands[cmd]);
								break;
							default:
								this.$ele.find('[data-notify="' + cmd + '"]').html(commands[cmd]);
						}
					}
					var posX = this.$ele.outerHeight() + parseInt(self.settings.spacing) + parseInt(self.settings.offset.y);
					self.reposition(posX);
				},
				close: function () {
					self.close();
				}
			};

		},
		buildNotify: function () {
			var content = this.settings.content;
			this.$ele = $(String.format(this.settings.template, this.settings.type, content.title, content.message, content.url, content.target));
			this.$ele.attr('data-notify-position', this.settings.placement.from + '-' + this.settings.placement.align);
			if (!this.settings.allow_dismiss) {
				this.$ele.find('[data-notify="dismiss"]').css('display', 'none');
			}
			if ((this.settings.delay <= 0 && !this.settings.showProgressbar) || !this.settings.showProgressbar) {
				this.$ele.find('[data-notify="progressbar"]').remove();
			}
		},
		setIcon: function () {

			this.$ele.addClass('alert-with-icon');

			if (this.settings.icon_type.toLowerCase() === 'class') {
				this.$ele.find('[data-notify="icon"]').html(this.settings.content.icon);
			}
			else {
				if (this.$ele.find('[data-notify="icon"]').is('img')) {
					this.$ele.find('[data-notify="icon"]').attr('src', this.settings.content.icon);
				}
				else {
					this.$ele.find('[data-notify="icon"]').append('<img src="' + this.settings.content.icon + '" alt="Notify Icon" />');
				}
			}
		},
		styleDismiss: function () {
			this.$ele.find('[data-notify="dismiss"]').css({
				position: 'absolute',
				right: '0',
				top: '5px',
				zIndex: this.settings.z_index + 2
			});
		},
		styleURL: function () {
			this.$ele.find('[data-notify="url"]').css({
				backgroundImage: 'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)',
				height: '100%',
				left: 0,
				position: 'absolute',
				top: 0,
				width: '100%',
				zIndex: this.settings.z_index + 1
			});
		},
		placement: function () {
			var self = this,
				offsetAmt = this.settings.offset.y,
				css = {
					display: 'inline-block',
					margin: '15px auto',
					position: this.settings.position ? this.settings.position : (this.settings.element === 'body' ? 'fixed' : 'absolute'),
					transition: 'all .5s ease-in-out',
					zIndex: this.settings.z_index
				},
				hasAnimation = false,
				settings = this.settings;

			$('[data-notify-position="' + this.settings.placement.from + '-' + this.settings.placement.align + '"]:not([data-closing="true"])').each(function () {
				offsetAmt = Math.max(offsetAmt, parseInt($(this).css(settings.placement.from)) + parseInt($(this).outerHeight()) + parseInt(settings.spacing));
			});
			if (this.settings.newest_on_top === true) {
				offsetAmt = this.settings.offset.y;
			}
			css[this.settings.placement.from] = offsetAmt + 'px';

			switch (this.settings.placement.align) {
				case "left":
				case "right":
					css[this.settings.placement.align] = this.settings.offset.x + 'px';
					break;
				case "center":
					css.left = 0;
					css.right = 0;
					break;
			}
			this.$ele.css(css).addClass(this.settings.animate.enter);
			$.each(Array('webkit-', 'moz-', 'o-', 'ms-', ''), function (index, prefix) {
				self.$ele[0].style[prefix + 'AnimationIterationCount'] = 1;
			});

			$(this.settings.element).append(this.$ele);

			if (this.settings.newest_on_top === true) {
				offsetAmt = (parseInt(offsetAmt) + parseInt(this.settings.spacing)) + this.$ele.outerHeight();
				this.reposition(offsetAmt);
			}

			if ($.isFunction(self.settings.onShow)) {
				self.settings.onShow.call(this.$ele);
			}

			this.$ele.one(this.animations.start, function () {
				hasAnimation = true;
			}).one(this.animations.end, function () {
				if ($.isFunction(self.settings.onShown)) {
					self.settings.onShown.call(this);
				}
			});

			setTimeout(function () {
				if (!hasAnimation) {
					if ($.isFunction(self.settings.onShown)) {
						self.settings.onShown.call(this);
					}
				}
			}, 600);
		},
		bind: function () {
			var self = this;

			this.$ele.find('[data-notify="dismiss"]').on('click', function () {
				self.close();
			});

			this.$ele.mouseover(function () {
				$(this).data('data-hover', "true");
			}).mouseout(function () {
				$(this).data('data-hover', "false");
			});
			this.$ele.data('data-hover', "false");

			if (this.settings.delay > 0) {
				self.$ele.data('notify-delay', self.settings.delay);
				var timer = setInterval(function () {
					var delay = parseInt(self.$ele.data('notify-delay')) - self.settings.timer;
					if ((self.$ele.data('data-hover') === 'false' && self.settings.mouse_over === "pause") || self.settings.mouse_over != "pause") {
						var percent = ((self.settings.delay - delay) / self.settings.delay) * 100;
						self.$ele.data('notify-delay', delay);
						self.$ele.find('[data-notify="progressbar"] > div').attr('aria-valuenow', percent).css('width', percent + '%');
					}
					if (delay <= -(self.settings.timer)) {
						clearInterval(timer);
						self.close();
					}
				}, self.settings.timer);
			}
		},
		close: function () {
			var self = this,
				posX = parseInt(this.$ele.css(this.settings.placement.from)),
				hasAnimation = false;

			this.$ele.data('closing', 'true').addClass(this.settings.animate.exit);
			self.reposition(posX);

			if ($.isFunction(self.settings.onClose)) {
				self.settings.onClose.call(this.$ele);
			}

			this.$ele.one(this.animations.start, function () {
				hasAnimation = true;
			}).one(this.animations.end, function () {
				$(this).remove();
				if ($.isFunction(self.settings.onClosed)) {
					self.settings.onClosed.call(this);
				}
			});

			setTimeout(function () {
				if (!hasAnimation) {
					self.$ele.remove();
					if (self.settings.onClosed) {
						self.settings.onClosed(self.$ele);
					}
				}
			}, 600);
		},
		reposition: function (posX) {
			var self = this,
				notifies = '[data-notify-position="' + this.settings.placement.from + '-' + this.settings.placement.align + '"]:not([data-closing="true"])',
				$elements = this.$ele.nextAll(notifies);
			if (this.settings.newest_on_top === true) {
				$elements = this.$ele.prevAll(notifies);
			}
			$elements.each(function () {
				$(this).css(self.settings.placement.from, posX);
				posX = (parseInt(posX) + parseInt(self.settings.spacing)) + $(this).outerHeight();
			});
		}
	});

	$.notify = function (content, options) {
		var plugin = new Notify(this, content, options);
		return plugin.notify;
	};
	$.notifyDefaults = function (options) {
		defaults = $.extend(true, {}, defaults, options);
		return defaults;
	};
	$.notifyClose = function (command) {
		if (typeof command === "undefined" || command === "all") {
			$('[data-notify]').find('[data-notify="dismiss"]').trigger('click');
		}
		else {
			$('[data-notify-position="' + command + '"]').find('[data-notify="dismiss"]').trigger('click');
		}
	};

}));